module.exports = "pegasus/assets/column-9-basic.png";